import { NavigationData } from "@ubisolutions/core";

export const ADMINISTRATION_NAVIGATION: NavigationData = {
    settings: {
        prefix: "administration",
    },
    routes: [
        // {
        //     key: "routing.administration.dashboard._title",
        //     route: "dashboard",
        //     icon: "dashboard",
        // },
        {
            key: "routing.administration.indoor-locations._title",
            icon: "home",
            route: "indoor-locations",
            children: [],
        },
        {
            key: "routing.administration.outdoor-locations._title",
            icon: "location_on",
            children: [
                {
                    key: "routing.administration.outdoor-locations.geo-fences._title",
                    icon: "near_me",
                    route: "outdoor-locations/geo-fences",
                    anyPermission: ["CircleZone", "PolygonZone"],
                },
            ],
        },
        {
            key: "routing.administration.hardware-management._title",
            icon: "graph_4",
            children: [
                {
                    key: "routing.administration.hardware-management.stations._title",
                    route: "hardware-management/stations",
                    icon: "router",
                    allPermissions: ["Station"],
                },
                {
                    key: "routing.administration.hardware-management.tags._title",
                    route: "hardware-management/tags",
                    icon: "nfc",
                    allPermissions: ["Tag"],
                },
                {
                    key: "routing.administration.hardware-management.tags-map._title",
                    route: "hardware-management/tags-map",
                    icon: "map",
                    allPermissions: ["Tag"],
                }
            ],
        },
        {
            key: "routing.administration.alerts._title",
            icon: "notifications",
            children: [
                {
                    key: "routing.administration.alerts.alert-config._title",
                    route: "alerts/alert-config",
                    icon: "settings",
                },
                {
                    key: "routing.administration.alerts.reports._title",
                    route: "alerts/reports",
                    icon: "summarize",
                    allPermissions: ["ReportDefinition"],
                },
            ],
        },
        {
            key: "routing.administration.ui-customization._title",
            route: "ui-customization",
            icon: "translate",
            allPermissions: ["UiClient"],
        },
        {
            key: "routing.administration.users-access_control._title",
            icon: "security",
            children: [
                {
                    key: "routing.administration.users-access_control.users._title",
                    route: "users-access_control/users",
                    icon: "supervisor_account",
                    allPermissions: ["User"],
                },
                {
                    key: "routing.administration.users-access_control.sub-tenants._title",
                    route: "users-access_control/sub-tenants",
                    icon: "groups",
                    allPermissions: ["SubTenant"],
                },
                {
                    key: "routing.administration.users-access_control.api-keys._title",
                    route: "users-access_control/api-keys",
                    icon: "key",
                    allPermissions: ["ApiKey"],
                },
            ],
        },
        {
            key: "routing.administration.imports._title",
            icon: "publish",
            route: "imports",
            anyPermission: ["ImportHistory"],
        },
        {
            key: "routing.administration.exports._title",
            icon: "file_export",
            route: "exports",
            anyPermission: ["ImportHistory"],
        },
    ],
};
